import { handleClickCard } from '../../../functions/functions';

/**
 * Componente optimizado para mostrar botones de momios patrocinados
 * Renderiza un botón interactivo con momio o un placeholder según disponibilidad
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.position - Posición del momio ('left', 'middle', 'right')
 * @param {Object} props.metadata - Objeto con datos de momios y URLs
 * @param {string} props.metadata[position + '_mm'] - Valor del momio para la posición
 * @param {string} props.metadata[position + '_url_mm'] - URL de apuesta para la posición
 * @param {boolean} props.showMomios - Controla la visibilidad de momios
 * @param {string} props.baseClass - Prefijo de clase CSS para styling
 * 
 * @returns {JSX.Element} Botón de momio o placeholder
 * 
 * @example
 * <MomioItemSponsored 
 *   position="left"
 *   metadata={{ left_mm: "1.85", left_url_mm: "https://bet.com" }}
 *   showMomios={true}
 *   baseClass="body-card-tenis__right-team"
 * />
 */
export default function MomioItemSponsored({ 
  position, 
  metadata = {}, 
  showMomios = false, 
  baseClass = '' 
}) {
  // Validación de parámetros requeridos
  if (!position || !baseClass) {
    return <div className="momio-error">Parámetros requeridos faltantes</div>;
  }

  // Extracción de datos con validación
  const momioValue = metadata[`${position}_mm`];
  const momioUrl = metadata[`${position}_url_mm`];
  const hasValidMomio = momioValue && showMomios;
  
  // Generación de clase CSS
  const containerClass = `${baseClass}-${position}-momio`;

  /**
   * Maneja el clic en el botón de momio
   */
  const handleMomioClick = (event) => {
    if (momioUrl) {
      handleClickCard(event, momioUrl);
    }
  };

  return (
    <div className={containerClass}>
      {hasValidMomio ? (
        <button 
          type="button" 
          className="momio-button"
          onClick={handleMomioClick}
          aria-label={`Apostar ${momioValue}`}
        >
          {momioValue}
        </button>
      ) : (
        <span className="span-momios" aria-hidden="true" />
      )}
    </div>
  );
}